<template>
  <div class="text-xs-center">
    <v-dialog v-model="show" width="50%">
      <v-toolbar class="toolbar-element" light flat height="90em">
        <v-toolbar-title class="toolbar-title">Historial de cambios</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="show = false"><v-icon color="grey darken-1">close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card class="body-content">
        <v-container>
          <v-card light flat class="pt-2">
            <v-card-text>
              <div v-for="item in history" :key="item.id">
                <v-layout row justify-left>
                  <v-flex xs3>
                    <span>{{ item.historyDate }}</span>
                  </v-flex>
                  <v-flex xs9>
                    {{ item.historyType }}
                    <span v-if="!subsanada"><b>{{ item.estado }}</b></span>
                    <span v-else-if="item.estado !== 'Presentada'"><b>{{ item.estado }}</b></span>
                    <span v-else-if="item.id === findFirstPresentada"><b>Presentada</b></span>
                    <span v-else><b>Subsanada</b></span>
                    {{ changedBy(item) }}
                    <span>{{(getRole(item.historyUser)) ? 'de ' : '' }}<b>{{ getRole(item.historyUser) }}</b></span>
                  </v-flex>
                </v-layout>
                <v-divider class="my-2" color="#DCDCDC"></v-divider>
              </div>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    history: Array,
    subsanada: Boolean
  },

  data () {
    return {
      show: false
    }
  },

  computed: {
    findFirstPresentada () {
      if (this.subsanada) {
        const firstPresentada = this.history.slice().reverse().find(item => item.estado === 'Presentada')
        return firstPresentada.id
      } else {
        return 0
      }
    }
  },

  methods: {
    showDialog () {
      this.show = true
    },
    isSaf (user) {
      return user.club === 'None'
    },
    hasUser (user) {
      return user.username.length
    },
    getRole (user) {
      if (this.isSaf(user)) {
        return 'LPF'
      }
      return user.club
    },
    getChangeReason (item) {
      return (item.historyChangeReason) ? `(${item.historyChangeReason})` : ''
    },
    changedBy (item) {
      if (!this.hasUser(item.historyUser)) {
        return `automáticamente ${this.getChangeReason(item)}`
      }
      return `por el usuario ${item.historyUser.firstName} ${item.historyUser.lastName}`
    }
  }
}
</script>

<style scoped>
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
}
.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}
.body-content {
  background-color: #eaeaea;
  padding-top: 0.5em;
  padding-bottom: 2.5em;
}
.asd {
  color: grey;
}
</style>
